import ComponentManager from '@/Management/ComponentManager';
import ControlFactory from '@/Factories/ControlFactory';
import AssociationSingleDropDownFactory from '@/Factories/ControlFactories/AssociationSingleDropDownFactory';
import { IDVGItemDTO } from "coreframetypings/dto";

export default class ExtIEGAssociationSingleDropdownFactory extends ControlFactory {

    private innerFactory: AssociationSingleDropDownFactory;
    
    public constructor(protected params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.innerFactory)
            return this.innerFactory.getControl();
        
        const dvgItem = this.params.detailViewItem as IDVGItemDTO;
        if (dvgItem?.listView == null)
            return $('<div>');
        dvgItem.listView.showButtonEdit = false;
        dvgItem.listView.showButtonCreate = false;
        this.innerFactory =  new AssociationSingleDropDownFactory(this.params);
        return this.innerFactory.getControl();
    }
}

ComponentManager.setFactory('ExtIEGAssociationSingleDropdown', ExtIEGAssociationSingleDropdownFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');